export const MODAL_ANIMATION_DURATION_MS = 300;

export const containerAnimationStyles = (duration) => ({
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
});

export const modalAnimationStyles = (duration) => ({
  transition: `transform ${duration}ms ease-in-out`,
  transform: "translateY(-100px)",
});

export const containerTransitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

export const modalTransitionStyles = {
  entering: { transform: "translateY(-100px)" },
  entered: { transform: "translateY(0px)" },
  exiting: { transform: "translateY(-100px)" },
  exited: { transform: "translateY(-100px)" },
};
